<template>
  <div id="app">
    <navigation-header></navigation-header>
    <keep-alive include="CustomerDetails">
      <router-view :key="$route.fullPath" />   <!-- Add this :key -->
    </keep-alive>
  </div>
</template>

<script>
  import NavigationHeader from './components/NavigationHeader.vue';
  import {signOut} from "./utils/auth";
  import {mapGetters} from "vuex";

  export default {
    components: {
      'navigation-header' : NavigationHeader
    },
    created () {
      window.addEventListener('beforeunload', this.closed_sign_out)
    },
    computed: {
      ...mapGetters({
        dont_sign_out: 'admin/dont_sign_out',
      }),
    },
    methods: {
      closed_sign_out() {
        if(this.dont_sign_out === 0) // direct opening of page. Opened via param customer id new tab sets it to 1
        {
          signOut();
        }
      }
    },
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }


     /* ====================== ACCOUNT LISTING TABLE ====================== */
   .account-listing {
     width: 100%;
     border-collapse: collapse;
     background: #ffffff;
     border-radius: 8px;
     overflow: hidden;
     box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
     font-size: 16px;
     margin-bottom: 20px;
   }

  .account-listing thead {
    background: #ffffff;
    color: #000000;
  }

  .account-listing th,
  .account-listing td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
  }

  .account-listing th {
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.5px;
  }

  .account-listing tbody tr:nth-child(even) {
    background-color: #f8f9fa;
  }

  .account-listing tbody tr:hover {
    background-color: #e9f0ff;
  }

  .account-listing.compact td,
  .account-listing.compact th {
    padding: 6px 10px;
  }

  .account-listing tbody tr:last-child td {
    border-bottom: none;
  }





</style>
